import React from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { PropTypes } from 'prop-types';

const UserPortalAccessDialog = ({
  open,
  portalAccess,
  handleClose,
  sendLoginDetailsToUser,
  removeLoginDetailsOfUser,
  employeeId,
  submitting
}) => {
  const isRemovingAccess = Boolean(portalAccess);
  const title = isRemovingAccess ? 'Remove portal access?' : 'Provide portal access?';
  const description = isRemovingAccess
    ? "The user's password will be removed, portal access will be turned off, calendar events will be cancelled, and ICT access will be removed."
    : 'Login details will be generated and emailed to this user.';
  const actionLabel = isRemovingAccess ? 'Remove Access' : 'Send Login Details';

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableEnforceFocus
      >
        <DialogTitle id="alert-dialog-title">{employeeId ? title : 'Save user first'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {employeeId ? description : 'Portal access can only be changed after the user exists in the database.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" disabled={submitting}>
            Cancel
          </Button>
          <Button
            onClick={isRemovingAccess ? removeLoginDetailsOfUser : sendLoginDetailsToUser}
            color="primary"
            disabled={!employeeId || submitting}
            autoFocus
          >
            {submitting && <CircularProgress size={16} style={{ marginRight: '8px' }} />}
            {actionLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserPortalAccessDialog;

UserPortalAccessDialog.propTypes = {
  open: PropTypes.bool,
  portalAccess: PropTypes.bool,
  handleClose: PropTypes.func,
  sendLoginDetailsToUser: PropTypes.func,
  removeLoginDetailsOfUser: PropTypes.func,
  employeeId: PropTypes.string,
  submitting: PropTypes.bool
};
